/**
 * @generated SignedSource<<4d9e6d2b060a3634c881637d97fb9764>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoCategoryEditScreenDeleteMutation$variables = {
  id: string;
};
export type TodoCategoryEditScreenDeleteMutation$data = {
  readonly todoCategory: {
    readonly delete: {
      readonly id: string;
    };
  } | null;
};
export type TodoCategoryEditScreenDeleteMutation = {
  response: TodoCategoryEditScreenDeleteMutation$data;
  variables: TodoCategoryEditScreenDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryEditScreenDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoCategoryMutation",
        "kind": "LinkedField",
        "name": "todoCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "delete",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoCategoryEditScreenDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoCategoryMutation",
        "kind": "LinkedField",
        "name": "todoCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "delete",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e20bbf073408e3bbf0c8c7fa52efe7a",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryEditScreenDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation TodoCategoryEditScreenDeleteMutation(\n  $id: ID!\n) {\n  todoCategory(id: $id) {\n    delete {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "858ded475e2b6305ac616e9b3aa82a11";

export default node;
